import { MediaListItem as MediaListItemResp } from "@jconradi/tutu-porn-api-client/src/users"
import { MediaItem } from "../MediaItem/MediaItem";
import { WatchMore } from "./WatchMore";

export interface MediaListItemProps {
    mediaListItem: MediaListItemResp;
}
export const MediaListItem = ({ mediaListItem }: MediaListItemProps) => {
    return (
        <div className="w-full">
            <MediaItem mediaListItem={mediaListItem} />
            <WatchMore mediaListItem={mediaListItem} />
        </div>
    )
}